import ActionType from '@/services/Action/ActionType';

class ActionStatus {
  /**
   * @returns {string}
   * @constructor
   */
  static APPROVED() {
    return 'approved';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static ASSIGNED() {
    return 'assigned';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static NO_ACCESS() {
    return 'no access';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static PENDING_APPROVAL() {
    return 'pending approval';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static QUERY() {
    return 'query';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static ANALYSIS() {
    return 'analysis';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static UNASSIGNED() {
    return 'unassigned';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static ON_HOLD() {
    return ActionStatus.QUERY();
  }

  /**
   * @returns {string}
   * @constructor
   */
  static PARTIAL() {
    return 'partial';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FULL() {
    return 'full';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static REJECTED() {
    return 'rejected';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static QUERY_RESPONSE() {
    return 'query response';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static NO_ACCESS_RESPONSE() {
    return 'no access response';
  }

  static getRoutes() {
    return [
      {
        name: 'assigned',
        path: 'assigned',
        statusFilter: this.ASSIGNED(),
      },
      {
        name: 'unassigned',
        path: 'unassigned',
        statusFilter: this.UNASSIGNED(),
      },
      {
        name: 'approvals',
        path: 'approvals',
        statusFilter: this.PENDING_APPROVAL(),
      },
      {
        name: 'no-access',
        path: 'no-access',
        statusFilter: this.NO_ACCESS(),
      },
      {
        name: 'query',
        path: 'queries',
        statusFilter: this.QUERY(),
      },
      {
        name: 'approved',
        path: 'approved',
        statusFilter: this.APPROVED(),
      },
      {
        name: 'analysis',
        path: 'analysis',
      },
      {
        name: 'actionFinder',
        path: 'actionFinder',
        statusFilter: null,
      },
      {
        name: 'partial',
        path: 'partial',
        statusFilter: ActionStatus.PARTIAL(),
      },
      {
        name: 'full',
        path: 'full',
        statusFilter: ActionStatus.FULL(),
      },
      {
        name: 'rejected',
        path: 'rejected',
        statusFilter: ActionStatus.REJECTED(),
      },
      {
        name: 'no-access-response',
        path: 'no-access-response',
        statusFilter: ActionStatus.NO_ACCESS_RESPONSE(),
      },
      {
        name: 'query-response',
        path: 'query-response',
        statusFilter: ActionStatus.QUERY_RESPONSE(),
      },
    ];
  }

  static getRouteByStatus(status) {
    const route = this.getRoutes().filter(r => r.statusFilter === status);
    return route[0].name;
  }

  static getStatusByRoute(routeName) {
    const route = this.getRoutes().filter(r => r.name === routeName);

    // Probably /actions (There is no status applied)
    if (route.length === 0) {
      return null;
    }

    return route[0].statusFilter;
  }

  static getAllStatus() {
    return [
      this.APPROVED(),
      this.ASSIGNED(),
      this.NO_ACCESS(),
      this.NO_ACCESS_RESPONSE(),
      this.PARTIAL(),
      this.PENDING_APPROVAL(),
      this.QUERY(),
      this.QUERY_RESPONSE(),
      this.REJECTED(),
      this.UNASSIGNED(),
    ];
  }

  static getGridStatusState() {
    const statusJson = {};
    const statuses = this.getAllStatus();
    statuses.push('actions');

    ActionType.getTypes().forEach(({ name }) => {
      statusJson[name] = {};
      statuses.forEach((status) => {
        statusJson[name][status] = {
          grid: {
            state: null,
            filters: null,
            sort: null,
          },
          external: {
            filters: null,
          },
        };
      });
    });

    return statusJson;
  }

  /**
   * Returns a readable label for secondary or completion statuses
   * @param status
   * @returns {null|string}
   */
  static getLabelForSecondaryOrCompletionStatus(status) {
    const mapping = {
      [ActionStatus.NO_ACCESS_RESPONSE()]: 'responded to no access',
      [ActionStatus.QUERY_RESPONSE()]: 'responded to query',
      [ActionStatus.REJECTED()]: 'rejected',
      [ActionStatus.PARTIAL()]: 'partially completed',
    };

    const label = mapping[status];

    if (!label) {
      return null;
    }

    return label;
  }

  static getTitle(status) {
    return {
      'approved': 'Approved',
      'unassigned': 'Unassigned',
      'assigned': 'Assigned',
      'pending approval': 'Pending Approval',
      'partial': 'Partially Complete',
      'rejected': 'Rejected',
      'query': 'Queried',
      'query response': 'Responded to Query',
      'no access': 'No Access',
      'no access response': 'Responded to No Access',
    }[status] || 'Open'
  }

  static openStatuses() {
    return [
      'assigned',
      'no access',
      'no access response',
      'partial',
      'pending approval',
      'query',
      'query response',
      'rejected',
      'unassigned',
    ];
  }
}

export default ActionStatus;
